import { IconButton } from '@/components/Buttons';
import { Row, ThemeText, View } from "@/components/Theme";
import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import { StyleSheet } from "react-native";

const DrawerTitle = ({title, onClose}) => {

    if (!title)
        return <IconButton style={styles.closeButtonAbsolute} icon="close" size={20} onPress={onClose} />;

    return (
        <Row style={{paddingBottom: 15}}>
            <View flex={1}>
                <ThemeText variant={['sm']} id={title} />
            </View>
            <IconButton icon="close" size={20} onPress={onClose} />
        </Row>
    )
    
};

const styles = StyleSheet.create({
    closeButtonAbsolute: {
        position: 'absolute',
        top: 15,
        right: 15,
        zIndex: 1000
    }
});

export default memo(DrawerTitle, isEqual);